import { registerGlobalHeader } from "./global-headers";

export async function handleApiError(
	response: Response,
	retryRequest: () => Promise<Response>
): Promise<Response> {
	try {
		console.debug("[Token Refresh] Starting token refresh flow", {
			url: response.url,
			status: response.status,
			statusText: response.statusText,
		});

		const refresh = localStorage.getItem("refresh_token");
		if (!refresh) {
			console.debug("[Token Refresh] No refresh token found in localStorage");
			throw new Error("No refresh token available");
		}

		// Try to refresh the token
		console.debug("[Token Refresh] Attempting to refresh token with API");
		const refreshResponse = await fetch("/api/v1/auth/refresh/", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ refresh }),
		});

		if (!refreshResponse.ok) {
			console.debug("[Token Refresh] Token refresh failed", {
				status: refreshResponse.status,
				statusText: refreshResponse.statusText,
			});
			throw new Error("Token refresh failed");
		}

		const data = await refreshResponse.json();
		console.debug("[Token Refresh] Token refresh successful, got new access token");
		const newToken = data.access;
		localStorage.setItem("access_token", newToken);
		if (data.refresh) {
			console.debug("[Token Refresh] Got new refresh token, updating storage");
			localStorage.setItem("refresh_token", data.refresh);
		}

		// Update global headers with new token
		registerGlobalHeader("Authorization", `Bearer ${newToken}`);

		// Retry the original request with the new token
		console.debug("[Token Refresh] Retrying original request", {
			url: response.url,
		});
		return retryRequest();
	} catch (error) {
		// If refresh fails, clear tokens and reject
		console.debug("[Token Refresh] Error during refresh, clearing tokens", {
			error,
		});
		localStorage.removeItem("access_token");
		localStorage.removeItem("refresh_token");
		return Promise.reject(error);
	}
}
